import axios from 'axios'
import { useAuthStore } from '../store/authStore'
import { openAuthPanel } from '../features/scene/sceneStore'

const API_BASE_URL = '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      useAuthStore.getState().logout()
      const path = window.location.pathname + window.location.search
      if (!path.includes('panel=auth')) {
        openAuthPanel('login', { returnTo: path })
      }
    }
    return Promise.reject(error)
  }
)

export default api

